import styled from 'styled-components';

import { MarketingPreferencesDS } from '@comicrelief/component-library';

import {
  ReusableInputStyles
} from '../global/Global.style';

const StyledMarketingPreferencesDS = styled(MarketingPreferencesDS)`
  margin-top: 1rem;

  /* Override CL change of some div layouts on breakpoints */
  div {
    flex-direction: column;

    /* This is not duplicate code, it is there to fix issues with CL assets not showing in build */
    span {
      &.icon-mp_permissionEmail {
        background-image: url("/assets/images/Email.svg");
      }

      &.icon-mp_permissionPhone {
        background-image: url("/assets/images/Phone.svg");
      }

      &.icon-mp_permissionSMS {
        background-image: url("/assets/images/Text.svg");
      }
    }

    &.selected {
      span {
      + input + span {
          background-image: url("/assets/images/CR_Tick_black.svg");
        }

        &.icon-mp_permissionEmail {
          background-image: url("/assets/images/Email--white.svg");
        }

        &.icon-mp_permissionPhone {
          background-image: url("/assets/images/Phone--white.svg");
        }

        &.icon-mp_permissionSMS {
          background-image: url("/assets/images/Text--white.svg");
        }
      }
    }

  }

  /* Top copy wrapper: */
  > div:first-child {
    padding: 0;
    margin: 0;
  }

  /* First option */
  > div:nth-child(2) {
    margin-top: 2rem;
  }

  /* Preferences links */
  > div:nth-child(5) {
    text-align: center;
  }

  /* Consistent input styles, fixed Error icon import */
  div > div:nth-child(2){
    ${ReusableInputStyles}

    /* bug fix, center icon on y-axis */
    label > div > div > div {
      top: 50%;
      transform: translateY(-50%);
    }
  }

  /* Preload 'selected' icons */
  &:after {
    position:absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
    content:
      url('/assets/images/Email--white.svg')
      url('/assets/images/Phone--white.svg')
      url('/assets/images/Text--white.svg') !important;
  }
`;

export { StyledMarketingPreferencesDS };
